import { render } from "./BoardVoteSettings.vue?vue&type=template&id=3988442f&scoped=true"
import script from "./BoardVoteSettings.vue?vue&type=script&lang=js"
export * from "./BoardVoteSettings.vue?vue&type=script&lang=js"

import "./BoardVoteSettings.vue?vue&type=style&index=0&id=3988442f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3988442f"]])

export default __exports__